import React from 'react';
import './Home.css';
import {Link} from '@reach/router';


const HomePage =() =>{
    return (
        <div class = "homepagecontent">
            <div className = "hometext">
                <h1>Welcome to LGBTQ+ hub</h1>
            </div>
            <div class = "gridcontainer">
                <div class = "gridbox">
                <Link to = "/gender"><p> Gender</p> </Link>
                </div>
                <div class = "gridbox">
                <Link to = "/sexuality"><p> Sexuality</p> </Link> 
                </div>
               <div class = "gridbox">
               <Link to = "/allies"> <p> Ally</p> </Link>
                </div>
            </div>
        </div>

    )
}

export default HomePage;